/**
 * title -> strig = titulo
 * content -> string = conteudo
 * image -> string = nome e extenção para imagem dentro do caminho especificado
 * _id -> string = id referente ao serviço
 */
import React from "react";
import './CardServices.css'
import getImage from "../../useFull/getImage";

const CardServices = props => {
    const { image, title, content, _id } = props

    const img = getImage('services', image);

    return (
        <div className="container-card-services" id={_id}>
            <div className="img-card-services" style={{ backgroundImage: `url(${img})` }} />
            <span className="text-title-secondary">{title}</span>
            <span dangerouslySetInnerHTML={{ __html: content }}></span>
        </div>
    )
}

export default CardServices